module.exports = __webpack_public_path__ + "img/4_105.bc28b4a2.png";